import React, { forwardRef, useContext } from "react";
import AppContext from "../appContext";
import roboResponde from "./img/robo-conecta-responde.svg";
import { formatTime, getNomeCompletoUsuario, getIniciaisUsuario } from "./repondeur-utils";
import { renderMarkdown } from "./markdown-lite";

const RepondeurPrint = forwardRef(({ messages, contexto }, ref) => {
	const context = useContext(AppContext);
	const avatarUsuario = context && context.avatar;
	const nome = getNomeCompletoUsuario() || "Usuário";
	const agora = new Date();

	return (
		<div ref={ref} className="repondeur-print">
			<h1>Conecta Responde</h1>
			<p className="repondeur-print-data">
				Conversa exportada em {agora.toLocaleDateString("pt-BR")} às {formatTime(agora)}
			</p>
			{contexto && contexto.exibirEvidencia && (
				<p className="repondeur-print-evidencia">
					Papel: {contexto.papel || "não informado"} · Categoria: {contexto.papelCategoria || "não informada"} · Tags
					enviadas: {(contexto.visibilities || []).join(", ") || "nenhuma"}
				</p>
			)}
			{messages
				.filter(msg => msg.from !== "system" && msg.text)
				.map(msg => (
					<div key={msg.id} className="repondeur-print-msg">
						<p className="repondeur-print-autor">
							{msg.from === "bot" ? (
								<span className="repondeur-print-avatar repondeur-print-avatar-bot" aria-hidden="true">
									<img className="repondeur-avatar-robo" src={roboResponde} alt="" />
								</span>
							) : (
								<span className="repondeur-print-avatar" aria-hidden="true">
									{avatarUsuario ? <img src={avatarUsuario} alt="" /> : getIniciaisUsuario() || "EU"}
								</span>
							)}
							{msg.from === "bot" ? "Conecta Responde" : nome}
							{msg.at ? " · " + formatTime(msg.at) : ""}
						</p>
						<div className="repondeur-print-texto">
							{msg.from === "bot" ? renderMarkdown(msg.text, false) : msg.text}
						</div>
					</div>
				))}
		</div>
	);
});

export default RepondeurPrint;
